<template>
  <div class="table-container" ref="scroll" >
    <v-table fixed-header :height="`${customHeight}vh`" density="compact">
      <thead>
        <tr>
          <th v-for="(field, i) in fields" :key="i">
            {{ field.label }}
          </th>
          <th> </th>
        </tr>
      </thead>

      <tbody ref="table">
        <tr v-for="(item, i) in items" :key="i">
          <td v-for="(field, j) in fields" :key="j" >
            <div>{{ item[field.key] }}</div>
          </td>
          <td>
            <div class="icon-box d-flex justify-content-between">
              <BIconTrash class="icon" @click="$emit('delete', item)"/>
            </div>
          </td>
        </tr>
        <td v-if="items.length === 0" :colspan=fields.length+1 class="remaining-box" >
          <span class="remaining-text">데이터가 없습니다.</span>
        </td>
      </tbody>
    </v-table>
  </div>
</template>

<script setup>
import { defineProps, ref } from "vue";
import {BIconPencilSquare, BIconTrash} from "bootstrap-icons-vue";

const emit = defineEmits(['delete','open-modal'])
const props = defineProps({
  fields: Object,
  items: Object,
  numOfTotal: Number,
  loadMore: Function,
  height: String,
  type: String,
  customHeight: String,
  regionList: Object
})

const scroll = ref("");
const table = ref(null);

</script>

<style scoped>
.table-container {
  font-size: 0.8rem;
  border-bottom: 1px solid #c9c8c8;
  border-top: 1px solid #c9c8c8;
}
th {
  text-align: center !important;
}

td {
  table-layout: fixed;
}
.v-table.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th {
  background: #e3e3e3 !important;
}
.v-table .v-table__wrapper > table > thead > tr > th {
  color: black;
}
.icon-box{
  width: 3.5rem;
  font-size: 1.5rem;
}
.icon{
  cursor:pointer
}
.remaining-box {
  height: 40px;
}
.remaining-text {

  color: black;
}
</style>